import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Package, Zap } from 'lucide-react';
export function ProductIntro() {
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-261">
      <div className="max-w-5xl mx-auto text-center" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-263">
          <div className="inline-block mb-6 px-6 py-3 bg-orange/10 border border-orange rounded-full text-orange font-bold" data-id="element-264">
            🏆 El Sistema N°1 para Entrenadores de Vóley Argentinos
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4" data-id="element-265">
            VOLEY 360 — Colección Completa
          </h2>

          <p className="text-xl md:text-2xl text-text-secondary mb-12" data-id="element-266">
            12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todas las categorías.
          </p>

          <div className="flex flex-wrap justify-center gap-4" data-id="element-267">
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-268">
              <FileText className="w-5 h-5 text-orange" data-id="element-269" />
              <span className="font-medium" data-id="element-270">+280 páginas</span>
            </div>
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-271">
              <Package className="w-5 h-5 text-orange" data-id="element-272" />
              <span className="font-medium" data-id="element-273">+200 ejercicios graficados</span>
            </div>
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-274">
              <Zap className="w-5 h-5 text-orange" data-id="element-275" />
              <span className="font-medium" data-id="element-276">Todas las categorías</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}